import React from "react"
import clsx from "clsx"
import Link from "next/link"
import Lottie from "react-lottie"
import S from "./no-results.module.scss"
import Animation from "@/animations/03_Sorry_DESK.json"

type NoResultProps = {
  query?: string | null
}

const NoResults: React.FC<NoResultProps> = ({ query = null }) => {
  const computedTitle = query
    ? `Sorry we couldn't find any matches for "${query}"`
    : "Sorry, we couldn't find any matches."

  return (
    <section className="u-section-padding text-center">
      <div className="container">
        <Lottie
          options={{ animationData: Animation }}
          style={{ maxWidth: 375 }}
        />
        <div className={S.wrapper}>
          <p className={clsx(S.title, "u-section-title pure mt-5 mb-3")}>
            {computedTitle}
          </p>
          {query && (
            <p className={S.content}>
              Make sure the spelling is correct. Try using a simpler search.
              Still having problems?&nbsp;
              <Link href="/contact">
                <u>Contact us</u>
              </Link>
              .
            </p>
          )}
        </div>
      </div>
    </section>
  )
}

export default NoResults
